import { Component, Input } from '@angular/core';
import { WelcomeData } from "../../..";
var HTML_TEMPLATE = "\n<div class=\"od-welcome\" *ngIf=\" _data !=null && _data.avatars !=null\">\n \t<div class=\"od-welcome-avatar\">\n\t\t<od-decorated-avatar [data]=\"avatar\" *ngFor=\"let avatar of _data.avatars;let i=index;\"></od-decorated-avatar>\n\t</div>\n\t<div class=\"od-welcome-text\">{{_data.text}}</div>\n<div>\n";
var CSS_STYLE = "\n.od-welcome {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.od-welcome-avatar {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.od-welcome-text {\n    padding: 0 15px 0 20px;\n    text-align: center;\n    font-size: 13px;\n    margin: 12px 0 16px 0 !important;\n    color: #354052 !important;\n}\n";
var Welcome = /** @class */ (function () {
    function Welcome() {
    }
    Object.defineProperty(Welcome.prototype, "data", {
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Welcome.decorators = [
        { type: Component, args: [{
                    selector: 'od-welcome',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Welcome.ctorParameters = function () { return []; };
    Welcome.propDecorators = {
        "data": [{ type: Input },],
    };
    return Welcome;
}());
export { Welcome };
//# sourceMappingURL=welcome.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/welcome/welcome.js
// module id = 438
// module chunks = 14